"use strict";

import $ from "jquery";
import { isParsleyForm, isValid } from "../../demi/js/scripts/parsley";

let currentIndex = 0;

export function initInScope($scope) {
    $scope.find('.js-mice-step-form').each(function () {
        let $form = $(this);
        let $steps = $form.find('.js-mice-step-form__step');
        let $legendItems = $form.find('.js-mice-step-form__legend-item');
        let $nextBtn = $form.find('.js-mice-step-form__next');
        let $prevBtn = $form.find('.js-mice-step-form__prev');
        let dataLayer;

        currentIndex = $steps.index($steps.filter('.is-current'));

        navigateTo(0, $form, $steps, $legendItems, $nextBtn, $prevBtn); // Start at the beginning

        $nextBtn.on('click', function () {
            if (isParsleyForm($form)) {
                if (isValid($form)) {
                    dataLayer = getDataLayer($steps, $form, (currentIndex +  1));

                    window.dataLayer.push(dataLayer);

                    navigateTo(currentIndex + 1, $form, $steps, $legendItems, $nextBtn, $prevBtn);
                }
            }
        });

        $prevBtn.on('click', function () {
            navigateTo(currentIndex - 1, $form, $steps, $legendItems, $nextBtn, $prevBtn);
        });

        let $ajaxFormBase = $form.closest('.js-ajax-form');

        $ajaxFormBase.on('submit.ajax-form', function () {
            dataLayer = getDataLayer($steps, $form, (currentIndex +  1))
        })

        $ajaxFormBase.on('success.ajax-form', function () {
            window.dataLayer.push(dataLayer);
        })
    });
}

function navigateTo(index, $form, $steps, $legendItems, $nextBtn, $prevBtn) {
    let $submitBtn = $form.find('.js-mice-step-form__submit');

    $steps.eq(currentIndex).removeClass('is-current');
    $steps.eq(index).addClass('is-current');
    $legendItems.eq(currentIndex).removeClass('is-current');
    $legendItems.eq(index).addClass('is-current');

    if (index !== 0) {
        $prevBtn.removeAttr('hidden');
    } else {
        $prevBtn.attr('hidden', 'true');
    }

    if ($submitBtn.length && $nextBtn.length) {
        if (index >= $steps.length - 1) {
            $nextBtn.attr('hidden', 'true');
            $submitBtn.removeAttr('hidden');
            showResults($form.find('.js-mice-step-form__result'), $form);
        } else {
            $nextBtn.removeAttr('hidden');
            $submitBtn.attr('hidden', 'true');
        }
    }

    currentIndex = index;
}

function showResults($result, $form) {
    const inputStates = getInputStates($form)

    $result.empty();
    inputStates.forEach((element) => {
        if (!$(this).data('mice-step-form-hidden')) {
            $result.append(renderResultItem(element));
        }
    });
}

function renderResultItem(element) {
    return $('<li>')
        .append($('<strong>')
            .addClass('mr-2')
            .text(`${element.label}: `))
        .append(document.createTextNode(element.value));
}

function getDataLayer($steps, $form, stepIndex) {
    const $currentStep = $steps.eq(stepIndex - 1)
    const inputStates = getInputStates($form, true);
    const location = $form.data('mice-step-form-tracking-location');
    const accommodation = $form.data('mice-step-form-tracking-accommodation');
    let dateFrom;

    let dataLayer = {
        'event': 'form_step_complete',
        'location': location ? location : 'overview',
        'step_count': stepIndex,
        'step_name': $steps.length === stepIndex ? 'summary' : $currentStep.data('mice-step-form-step')
    }

    if (accommodation) {
        dataLayer.accommodation = accommodation;
    }

    inputStates.forEach(function (input) {
        if (input.value) {
            if (input.label === 'date_from') {
                const formatedDateObj = formatTrackingDate(input.value);

                dataLayer.date_from = formatedDateObj.joinedDate;
                dateFrom = new Date(formatedDateObj.dateString);
            } else if (dateFrom && input.label === 'date_to') {
                const formatedDateObj = formatTrackingDate(input.value);

                const dateTo = new Date(formatedDateObj.dateString);
                const timeDiff = Math.abs(dateTo - dateFrom);

                dataLayer.date_to = formatedDateObj.joinedDate;
                dataLayer.night_count = Math.ceil(timeDiff / (1000 * 3600 * 24));
            } else {
                dataLayer[input.label] = !isNaN(input.value) ? parseInt(input.value) : input.value;
            }
        }
    });

    return dataLayer
}

function getInputStates($wrapper, isForTracking = false) {
    let $formElements = $wrapper.find('input:not([type=hidden]), textarea, select');
    let inputStates = [];

    $formElements.each(function () {
        let $input = $(this);
        let dataSet = $input.data();

        if (!dataSet.miceStepFormHidden) {
            let newInputState;
            let label = dataSet.miceStepFormLabel ? dataSet.miceStepFormLabel : $input.attr('name')
            let skipValues = false

            if (isForTracking) {
                label = dataSet.miceStepFormTrackingLabel ? dataSet.miceStepFormTrackingLabel : $input.attr('name')
                if (dataSet.miceStepFormSkipTracking) {
                    skipValues = true
                }
            }

            if (!skipValues) {
                if ($input.prop('tagName') === 'SELECT') {
                    let $option = $input.find('option:selected');
                    newInputState = {
                        label: label,
                        value: $option.text()?.trim() || $input.val()?.trim()
                    };
                } else if ($input.data('multiselect')) {
                    newInputState = {
                        label: label,
                        value: $input.attr('data-labels')
                    };
                } else {
                    newInputState = {
                        label: label,
                        value: $input.val()
                    };
                }
            }

            if (newInputState) {
                inputStates.push(newInputState);
            }
        }
    });

    return  inputStates
}

function formatTrackingDate(date) {
    let dateArr = date.split('.');
    dateArr.reverse();

    return {
        joinedDate: dateArr.join(''),
        dateString: dateArr.join('-') + 'T00:00:00'
    }
}